import { useTranslation } from "react-i18next";
import BigH1 from "../Atoms/BigH1";
import Section from "../Atoms/Section";
import React from "react";
import * as api from '../../api';
import styled from "styled-components";
import BlueButton from "../Atoms/BlueButton";
import { Link } from "react-router-dom";
import logo_en from "../../Components/img/logo_en.jpg"
import dayjs from "dayjs";
import { makeUrlsAndEmailsLinks } from "../Utils/Format";
import Popup from "../Atoms/Popup";
import Spinner from "../../Plateforme/Atoms/Spinner";

const EventsContainer = styled.div`

    display: flex;
    flex-direction: column;
    gap: 40px;

    & > div {
        margin: 10px 0; 
        flex-wrap: wrap;
        /* margin-bottom: 40px; */
    }
`

const EventCard = styled.div`
    & p {
        text-align: justify;
        white-space: pre-wrap;
        clear: both;
    }

    & img {
        /* width: 150px; */
        /* height:fit-content; */
        margin: 0 20px 20px 0;
        float:left;
    }

    & span {
        flex-wrap: wrap;  
        clear: both;
    }

    & p {
        margin-top: 20px;
    }

    & a {
        margin:10px 0;
    }

    & h2 {
        /* text-transform:uppercase */
    }
`

const Events = (props) => {

    const [registeredEvents, setRegisteredEvents] = React.useState([]);
    const [unregisteredEvents, setUnregisteredEvents] = React.useState([]);
    const [documentPopupForEvent, setDocumentPopupForEvent] = React.useState(null);
    const [documentBeingUploaded, setDocumentBeingUploaded] = React.useState(null);

    const { i18n } = useTranslation('common');

    // const allowedEventIds = [
    //     "65bbd3474931755ed1c4bbef",
    //     // "6602d906a1ab43a149e591b4"
    // ]

    React.useEffect(() => {
        loadEventsAndUserParticipation();
    }, [props.fullUser, props.fullUserLoading]);

    function loadEventsAndUserParticipation(whenDone, eventIdToLoad){
        if (props.fullUser && !props.fullUserLoading) {
            api.getEvents().then((resEvents) => {
                // console.log('resEvents', resEvents.data);
                api.getUserParticipations({ userid: props.fullUser.user._id }).then((userParticipations) => {
                    const _registeredEvents = [];
                    const _unregisteredEvents = [];
                    for (let i = 0; i < resEvents.data.length; i++) {
                        const event = resEvents.data[i];

                        // ////// COMMENT BEFORE DEPLOYING !!! ///////
                        // //for developpement, if event id is 67590da5499bcc995c210b40, show it
                        // if (event._id === "67590da5499bcc995c210b40"){
                        //     _unregisteredEvents.push(event);
                        //     continue;
                        // }
                        // ////// COMMENT BEFORE DEPLOYING !!! ///////

                        //hide event before 2024
                        if (new Date(event.inscriptions_end_date).setHours(23, 59, 59) < new Date(2024, 0, 1)){
                            continue;
                        }
                        const matchingParticipation = userParticipations.data.find(participation => participation.eventId === event._id);
                        if (matchingParticipation) {
                            _registeredEvents.push({ ...event, participation: matchingParticipation });
                            continue;
                        }
                        if (new Date(event.inscriptions_end_date).setHours(23, 59, 59) > new Date() && new Date(event.inscriptions_start_date) < new Date()) {
                            _unregisteredEvents.push(event);
                        }
                    }
                    setRegisteredEvents(_registeredEvents);
                    setUnregisteredEvents(_unregisteredEvents);
                    
                    if (whenDone) whenDone();
                    if (eventIdToLoad) {
                        const eventToLoad = _registeredEvents.find(event => event._id === eventIdToLoad);
                        if (eventToLoad) setDocumentPopupForEvent(eventToLoad);
                    }
                });
            });
        }
    }

    // console.log('props.fullUser', props.fullUser);

    // const otherEventTitle = registeredEvents.length > 0 ? (i18n.language === "fr" ? "Les autres événements" : "Other events") : (i18n.language === "fr" ? "Les événements" : "Events");

    if (!props.fullUser && !props.fullUserLoading) return (<>
        <Section className="padding">
            <BigH1>{i18n.language === "fr" ? "VOS ÉVÈNEMENTS" : "YOUR EVENTS"}</BigH1><br />
        </Section>
        <Section className="padding">
            <span className="centered">{i18n.language === "fr" ? "Veuillez vous connecter pour accéder aux événements." : "Please login to access events."}</span><br/><br />
            <Link to={"/?thengotoevent=yes"}>
                <BlueButton className="centered">{i18n.language === "fr" ? "Connexion" : "Login"}</BlueButton>
            </Link>
        </Section>
    </>);

    if (!props.fullUser?.user?.companyHubspotID && props.fullUser?.user?.role !== "admin") return (<>
        <Section className="padding">
            <BigH1>{i18n.language === "fr" ? "VOS ÉVÈNEMENTS" : "YOUR EVENTS"}</BigH1><br />
        </Section>
        <Section className="padding">
            <span className="centered">{i18n.language === "fr" ? "Aucune entreprise associée à votre compte." : "No company associated with your account."}</span><br/>
            <span className="centered">{i18n.language === "fr" ? "Vous devez créer une entreprise pour accéder aux événements." : "You must create a company to access events."}</span><br/><br/>
            <Link to={"/mycompany"}>
                <BlueButton className="centered">{i18n.language === "fr" ? "Créer une entreprise" : "Create a company"}</BlueButton>
            </Link>
        </Section>
    </>);

    return (<>
        <Section className="padding">
            <BigH1>{i18n.language === "fr" ? "VOS ÉVÈNEMENTS" : "YOUR EVENTS"}</BigH1><br />
            <span style={{ fontSize: "22px" }}>{i18n.language === "fr" ? "Accédez ou inscrivez-vous aux événements Le FRENCH DESIGN." : "Access or register for Le FRENCH DESIGN events."}</span><br />
        </Section>
        {(false && registeredEvents.length === 0 && unregisteredEvents.length === 0) ? <Section className="padding">
            <span>{i18n.language === "fr" ? "Aucun événement." : "No event."}</span>
        </Section> : <><Section className="padding">
            <EventsContainer>
                {registeredEvents.map(event => {
                    const imageUrl = process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.logo_path;
                    return (
                        <EventCard key={event._id}>
                            <div className="flexblock">
                                <div style={{flex: "0 0 250px"}}>
                                    {(i18n.language !== "fr" && event._id === "65bbd3474931755ed1c4bbef") ?
                                        <img src={logo_en} alt="Event Logo en" />
                                    :
                                        <img src={imageUrl} alt="Event Logo" />
                                    }
                                </div>
                                <div>
                                    <h2>{i18n.language === "fr" ? event.title_fr : (event.title_en ? event.title_en : event.title_fr)}</h2><br />
                                    {event._id === "65bbd3474931755ed1c4bbef" ? 
                                        <><h3 className="blacklower">{i18n.language === "fr" ? "Le mardi 4 juin 2024 en présentiel à Paris" : "In person on Tuesday, June 4, 2024 in Paris"}</h3>
                                        <h3 className="blacklower">{i18n.language === "fr" ? "Le vendredi 7 juin 2024 en ligne (Zoom)" : "Online on Friday, June 7, 2024 (Zoom)"}</h3></>
                                    :
                                        <EventDate event={event}/>
                                    }
                                    {/* {event.document_to_sign_path && event.participation && event.participation.type[3] === "b" && <BlueButton onClick={() => setDocumentPopupForEvent(event)} className="centered">{i18n.language === "fr" ? "ACCORD DE CONFIDENTIALITE " : "CONFIDENTIALITY AGREEMENT"}</BlueButton>} */}
                                    <div style={{whiteSpace:"pre-wrap",textAlign:"justify"}}>{i18n.language === "fr" ? makeUrlsAndEmailsLinks(event.description_fr) : makeUrlsAndEmailsLinks(event.description_en)}</div><br/>
                                    
                                </div>
                            </div>
                            <div style={{display: "flex", justifyContent: "space-between", flexDirection:"column", alignItems:"center" }}>
                                {event.type === "fd100" ?
                                    // are the registrations still open ?
                                    // event.inscriptions_end_date is in format 2025-05-09T00:00:00.000Z
                                    ((new Date(event.inscriptions_end_date).getTime() > new Date().getTime() && new Date(event.inscriptions_start_date).getTime() < new Date().getTime()) ?
                                        <Link to={"/evenements/fd100editparticipation?eid=" + event._id + "&uid=" + props.fullUser.user._id}>
                                            <BlueButton>{i18n.language === "fr" ? "Ma candidature" : "My application"}</BlueButton>
                                        </Link>
                                    :
                                        <Link to={"/mycandidatures"}>
                                            <BlueButton>{i18n.language === "fr" ? "Mes candidatures" : "My applications"}</BlueButton>
                                        </Link>
                                    )
                                :
                                    <Link to={"/evenements/editparticipation?eid=" + event._id + "&uid=" + props.fullUser.user._id}>
                                        <BlueButton>{i18n.language === "fr" ? "Mes infos" : "My information"}</BlueButton>
                                    </Link>
                                }
                                {/* {event.participation && event.participation.type[3] === "b" && event._id !== "65bbd3474931755ed1c4bbef" && 
                                    <Link to={"/evenements/sdebcandidature?eid=" + event._id + "&uid=" + props.fullUser.user._id}>
                                        <BlueButton>{i18n.language === "fr" ? "CANDIDATER POUR UN RENDEZ-VOUS " : "Applications"}</BlueButton>
                                    </Link>
                                } */}
                                {/* {event.participation && event.participation.type[3] === "b" && event._id === "65bbd3474931755ed1c4bbef" && <Link to={"/evenements/sdebcandidature?eid=" + event._id + "&uid=" + props.fullUser.user._id}><BlueButton>{i18n.language === "fr" ? "MES CANDIDATURES " : "Applications"}</BlueButton></Link>} */}
                                {event.document_to_sign_path && event.participation && event.participation.type[3] === "b" && <BlueButton className="fitwidth" onClick={() => setDocumentPopupForEvent(event)} >{i18n.language === "fr" ? "ACCORD DE CONFIDENTIALITE " : "CONFIDENTIALITY AGREEMENT"}</BlueButton>}
                                {event.participation && event.participation.type[3] === "b" && event._id === "65bbd3474931755ed1c4bbef" && <Link to={"/evenements/prescripteurs?eid=" + event._id + "&uid=" + props.fullUser.user._id}><BlueButton className="fitwidth" >{i18n.language === "fr" ? "PROFILS DE MES PRESCRIPTEURS " : "MY SPECIFIERS PROFILES"}</BlueButton></Link>}
                            </div>
                        </EventCard>
                    );
                })}
                {/* SDO 2026 - Speed Dating Design Objet */}
                <EventCard>
                    <div className="flexblock">
                        <div style={{flex: "0 0 250px"}}>
                            <img src="/img/sdo2026/bandeau-logo.png" alt="Speed Dating Design Objet" style={{width: '100%', borderRadius: 8}} />
                        </div>
                        <div>
                            <h2>Speed Dating Design Objet</h2><br />
                            <h3 className="blacklower">{i18n.language === "fr" ? "Mardi 29 septembre 2026, 14h-18h — En présentiel" : "Tuesday September 29, 2026, 2pm-6pm — In person"}</h3>
                            <br/>
                            <div style={{whiteSpace:"pre-wrap",textAlign:"justify"}}>
                                {i18n.language === "fr"
                                    ? <>
                                        <strong>Rencontres entre fabricants</strong> (fabricants, éditeurs, galeries…) <strong>et designers produit</strong>.
                                        <br/><br/>
                                        Une opportunité exceptionnelle offerte aux entreprises françaises de développer de nouvelles collaborations (nouvelles pièces, nouvelles collections…).
                                        <br/><br/>
                                        <strong>Jusqu'à 8 rendez-vous en 1/2 journée.</strong>
                                    </>
                                    : <>
                                        <strong>Meetings between manufacturers</strong> (manufacturers, publishers, galleries…) <strong>and product designers</strong>.
                                        <br/><br/>
                                        An exceptional opportunity for French companies to develop new collaborations (new pieces, new collections…).
                                        <br/><br/>
                                        <strong>Up to 8 meetings in half a day.</strong>
                                    </>}
                            </div><br/>
                        </div>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", flexDirection:"column", alignItems:"center" }}>
                        <Link to={"/evenements/sdo2026"}>
                            <BlueButton>{i18n.language === "fr" ? "Plus d'infos" : "More info"}</BlueButton>
                        </Link>
                    </div>
                </EventCard>

                
                {unregisteredEvents.map(event => {
                    const imageUrl = process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.logo_path;
                    return (
                        <EventCard key={event._id}>
                             <div className="flexblock">
                                <div style={{flex: "0 0 250px"}}>
                                    {(i18n.language !== "fr" && event._id === "65bbd3474931755ed1c4bbef") ?
                                        <img src={logo_en} alt="Event Logo en" />
                                    :
                                        <img src={imageUrl} alt="Event Logo" />
                                    }
                                </div>
                                <div>
                                    <h2>{i18n.language === "fr" ? event.title_fr : (event.title_en ? event.title_en : event.title_fr)}</h2><br />
                                    {event._id === "65bbd3474931755ed1c4bbef" ? 
                                        <><h3 className="blacklower">{i18n.language === "fr" ? "Le mardi 4 juin 2024 en présentiel à Paris" : "In person on Tuesday, June 4, 2024 in Paris"}</h3>
                                        <h3 className="blacklower">{i18n.language === "fr" ? "Le vendredi 7 juin 2024 en ligne (Zoom)" : "Online on Friday, June 7, 2024 (Zoom)"}</h3></>
                                    :
                                        <EventDate event={event}/>
                                    }
                                    {/* {event.document_to_sign_path && event.participation && event.participation.type[3] === "b" && <BlueButton onClick={() => setDocumentPopupForEvent(event)} className="centered">{i18n.language === "fr" ? "ACCORD DE CONFIDENTIALITE " : "CONFIDENTIALITY AGREEMENT"}</BlueButton>} */}
                                    <div style={{whiteSpace:"pre-wrap",textAlign:"justify"}}>{i18n.language === "fr" ? makeUrlsAndEmailsLinks(event.description_fr) : makeUrlsAndEmailsLinks(event.description_en)}</div><br/>
                                    
                                </div>
                            </div>
                            <div style={{display: "flex", justifyContent: "space-between", flexDirection:"column", alignItems:"center" }}>
                                <Link to={"/evenements/learnmore?eid=" + event._id}>
                                    <BlueButton>{i18n.language === "fr" ? "Inscription" : "Register"}</BlueButton>
                                </Link>
                            </div>
                        </EventCard>
                    );
                })}
            </EventsContainer>
        </Section>
        {documentPopupForEvent && <Popup close={() => setDocumentPopupForEvent(null)}>
            {i18n.language === "fr" ? "Pour participer à cet événement, vous devez télécharger l'accord de confidentialité, le signer, puis l'uploader ci-dessous." : "To participate in this event, you must download the confidentiality agreement, sign it, and then upload it below."}
            <br/><br/>
            <a download href={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + documentPopupForEvent.document_to_sign_path + "?downloadfile=true"} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Télécharger l'accord de confidentialité" : "Download the confidentiality agreement"}</a>
            <br/><br/>
            {documentBeingUploaded ? <Spinner /> : <>
                {documentPopupForEvent.participation.data.confidentiality_agreement && <>
                    <strong>{i18n.language === "fr" ? "Votre accord de confidentialité signé est enrégistré." : "Your signed confidentiality agreement is saved."}</strong>
                    <br/>
                    <a href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + documentPopupForEvent.participation.data.confidentiality_agreement.uploaded_path} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Consultez votre accord de confidentialité signé" : "View your signed confidentiality agreement"}</a>
                    <br/>
                    <span>{i18n.language === "fr" ? "Si vous avez besoin de le changer, vous pouvez uploader un nouveau document ci dessous." : "If you need to change it, you can upload a new document below."}</span>
                    <br/>
                </>}
                <input type="file" accept=".pdf" onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const submission = new FormData();
                    submission.append("confidentiality_agreement", e.target.files[0]);
                    submission.append("participation_id", documentPopupForEvent.participation._id);
                    submission.append("event_id", documentPopupForEvent._id);

                    setDocumentBeingUploaded(true);
                    api.uploadConfidentialityAgreement(submission).then((res) => {
                        // console.log('uploadConfidentialityAgreement :', res);
                        loadEventsAndUserParticipation(() => setDocumentBeingUploaded(false), documentPopupForEvent._id);
                        // api.updateParticipation({ eventId: documentPopupForEvent._id, userId: props.fullUser.user._id, documentPath: res.data.fileName }).then((res) => {
                        //     console.log('updateParticipation', res);
                        //     setDocumentPopupForEvent(null);
                        // });
                    }).catch(() => {
                        alert('Erreur lors de l\'upload du document, assurez-vous que le fichier fait moins de 50mo.');
                        setDocumentBeingUploaded(false);
                    });
                }} />
            </>}
        </Popup>}
        </>
    }
    </>);
}

const EventDate = ({event}) => {

    const { i18n } = useTranslation('common');

    if(!event.main_date) return ("");

    if(event.main_date === event.online_date) return (
        <h3 className="blacklower">{i18n.language === "fr" ? " Le " : ""}{dayjs(event.main_date).format('dddd D MMMM YYYY')} {i18n.language === "fr" ? "en présentiel" : "in person"} <EventLocalisation event={event} /></h3>
    );

    if(event.main_date > event.online_date) return (
        <><h3 className="blacklower">{i18n.language === "fr" ? " Le " : ""}{dayjs(event.online_date).format('dddd D MMMM YYYY')} {i18n.language === "fr" ? "en ligne (Zoom)" : "online (Zoom)"}</h3>
        <h3 className="blacklower">{i18n.language === "fr" ? " Le " : ""}{dayjs(event.main_date).format('dddd D MMMM YYYY')} {i18n.language === "fr" ? "en présentiel" : "in person"} <EventLocalisation event={event} /></h3></>
    );

    return (
        <><h3 className="blacklower">{i18n.language === "fr" ? " Le " : ""}{dayjs(event.main_date).format('dddd D MMMM YYYY')} {i18n.language === "fr" ? "en présentiel" : "in person"} <EventLocalisation event={event} /></h3>
        <h3 className="blacklower">{i18n.language === "fr" ? " Le " : ""}{dayjs(event.online_date).format('dddd D MMMM YYYY')} {i18n.language === "fr" ? "en ligne (Zoom)" : "online (Zoom)"}</h3></>
    );
}

const EventLocalisation = ({event}) => {
    
        const { i18n } = useTranslation('common');
    
        if(!event.localisation) return ("");
    
        if(i18n.language === "fr") return (
            " à " + event.localisation
        );
    
        return (
            " in " + event.localisation
        );
}

export default Events;